// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PropertiesEditorTabsContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import { action } from 'mobx';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from 'share/enhancers/Izenda.Connect';
import BrowserUtils from 'share/utils/Izenda.BrowserUtils';
import PropertiesEditorManager from 'modules/Izenda.PropertiesEditorManager';
import PropertiesEditorContainer from './Izenda.PropertiesEditorContainer';
import { Tabs, Tab } from 'share/components/controls/Izenda.Tab';
import classnames from 'classnames';
import { last, invoke, map, has, filter, keys } from 'lodash/fp';

@connect()
class PropertiesEditorTabsContainer extends Component {
  static propTypes = {
    editors: PropTypes.object.isRequired,
    defaultParams: PropTypes.array,
    onChangeActiveEditor: PropTypes.func,
    onSetActiveEditor: PropTypes.func
  };

  editorInfo: any;
  propConfigByTabs: any;
  editorId: string;
  activeTab: string;

  setEditorInfo = (editorInfo: any) => {
    this.editorInfo = editorInfo;
  };

  /**
   * List of editor are registed, first editor will be show as active tab
   * @param {[Array]} editorsInfo
   */
  setPropertySchemas = (editorId: string, editorsInfo: Array<any>, activeEditor: string) => {
    const { propConfigByTabs, props } = this;

    editorsInfo = editorsInfo || [];

    editorsInfo.forEach(function(editor) {
      editor.schemaDef && (propConfigByTabs[editor.name] = editor.schemaDef);
    });

    this.editorId = editorId;
    this.activeTab = activeEditor;

    props.onSetActiveEditor && props.onSetActiveEditor(this.activeTab);
    props.onChangeActiveEditor && props.onChangeActiveEditor(this.activeTab);
  };

  constructor(props: any) {
    super(props);
    const { editors, defaultParams } = props;

    this.propConfigByTabs = {};

    const defaultConfigByTabs = PropertiesEditorManager.addEditor(this, editors, defaultParams);
    $izenda.extend(this.propConfigByTabs, defaultConfigByTabs);
  }

  componentWillUnmount() {
    // reset config of all editor-properties
    this.propConfigByTabs = {};
    PropertiesEditorManager.resetEditor(this.props.editors);
  }

  @action
  beforeRender = (newActiveEditor: any) => {
    const {
      props: { editors }
    } = this;
    const propsEditorId = PropertiesEditorManager.findEditorId([
      {
        name: newActiveEditor
      }
    ]);

    PropertiesEditorManager.takeAction.call(
      null,
      propsEditorId,
      'beforeRender',
      newActiveEditor,
      editors[newActiveEditor]
    );
  };

  @action
  afterRender = (index: number, selectedPanel: string, selectedTabMenu: string, activeTabKey: string) => {
    const {
      props,
      props: { editors }
    } = this;

    const propsEditorId = PropertiesEditorManager.findEditorId([
      {
        name: activeTabKey
      }
    ]);

    props.onChangeActiveEditor && props.onChangeActiveEditor(activeTabKey);

    PropertiesEditorManager.takeAction.call(null, propsEditorId, 'afterRender', activeTabKey, editors[activeTabKey]);
    PropertiesEditorManager.setActiveEditor(activeTabKey);
  };

  render() {
    const {
      props: { editors, className }
    } = this;
    const isResponsive = BrowserUtils.isMobileDevice();
    const propConfigByTabs = this.propConfigByTabs;

    invoke('onRender', editors[this.activeTab]);

    return (
      <Tabs
        activeTabKey={this.activeTab}
        className={className}
        isResponsive={isResponsive}
        canChangeTab={canChangeTab}
        beforeChangeTab={this.beforeRender}
        onChange={this.afterRender}
      >
        {map(renderTab, getShowingTabNames(editors))}
      </Tabs>
    );

    function getShowingTabNames(editors) {
      const editorNames = keys(editors);

      return filter(function(name) {
        return has('isShow', editors[name]) ? invoke('isShow', editors[name]) : true;
      }, editorNames);
    }

    function canChangeTab() {
      const nextTab = last(arguments);

      return PropertiesEditorManager.canSwitch([
        {
          name: nextTab
        }
      ]);
    }

    function renderTab(tabKey) {
      const tabInfo = editors[tabKey];

      if (has('isShow', tabInfo) && !tabInfo.isShow()) {
        return null;
      }

      const classes = classnames({
        'tab-properties': !isResponsive
      });

      return (
        <Tab title={tabInfo.title} tabKey={tabKey} key={tabKey} headerClassName={classes}>
          <PropertiesEditorContainer
            className='u_fullHeight izenda-PropertiesContainer'
            propertyConfig={propConfigByTabs[tabKey]}
          />
        </Tab>
      );
    }
  }
}
export default PropertiesEditorTabsContainer;



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.PropertiesEditorTabsContainer.js